































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import moment from 'moment';
import VueToExcel from 'vue-json-excel';
import CandidateCultureGradeDetails from '@/domain/selective-process/entity/candidate/candidate-culture-grade-details.entity';
import CandidateService from '@/domain/selective-process/service/candidate.service';
import Loading from '@/shared/loading/loading.component.vue';
import ResetSurveyModal from '@/views/selective-process/modal/reset-survey-modal.component.vue';
import TableHeaders from './fit-cultural-result-header.json';


@Component({
  components: {
    Loading,
    ResetSurveyModal,
    VueToExcel,
  },
})
export default class FitCulturalComponent extends Vue {
  @Prop({
    type: String,
    required: true,
  }) candidateAssessmentId!: string;

  @Prop({
    type: Boolean,
    required: true,
  }) hasResetPermission!: boolean;

  @Prop({
    type: String,
    required: true,
  }) candidateName!: string;

  cultureResult: CandidateCultureGradeDetails = new CandidateCultureGradeDetails();

  loading: boolean = false;

  headers = TableHeaders;

  openResetModal: boolean = false;

  xlsFields: any = {
    Questão: 'questionPosition',
    Titulo: 'questionTitle',
    Resposta: 'value',
    Nota: 'grade',
    'Nota Máxima': 'maxGrade',
  }

  created() {
    this.fetchCultureResult();
  }

  async fetchCultureResult() {
    this.loading = true;
    await CandidateService.getCultureResult(this.candidateAssessmentId)
      .then(((response) => {
        this.cultureResult = response;
      }))
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  formateDate(data: string): string {
    return data ? moment(data).format('DD/MM/YYYY HH:mm') : '';
  }
}
